import clsx from 'clsx'
import * as React from 'react'

export function Paragraph({
  className,
  ...props
}: React.HTMLProps<HTMLParagraphElement>) {
  return <p className={clsx('text-gray leading-7', className)} {...props} />
}
